import React, { forwardRef } from "react";

import { StyledButton } from "./style";

export enum DateInputLabel {
  StartDate = "start date",
  EndDate = "end date",
  SettlementPeriod = "settlement date & period",
}

export interface Props {
  value: string;
  appendText?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  dateInputLabel: DateInputLabel;
}

const DateInput = forwardRef(function dateInput(
  { value, onClick, isDisabled = false, dateInputLabel, appendText }: Props,
  ref: React.Ref<HTMLButtonElement>
) {
  const buttonText = `${value}${appendText ? ` ${appendText}` : ""}`;
  return (
    <StyledButton
      type="button"
      onClick={onClick}
      dataTestId="date-input"
      ref={ref}
      disabled={isDisabled}
      ariaLabel={`Change ${dateInputLabel} from ${value}`}
      ariaDisabled={isDisabled}
      className="bottom-border"
      buttonText={buttonText}
    />
  );
});

export default DateInput;
